<footer id="footer">
    <div class="twc-row twc-m-0">
        <div class="twc-col-md-1"></div>
        <div class="twc-col-md-4">
            <span class="twc-body">{{'FOOTER.ALL_RIGHTS_RESERVED' | translate : {currentYear: year} }}</span>
        </div>
        <div class="twc-col-md-3">
            <span class="twc-body link" (click)="templateService.showTemplate(templateTypes.LEGAL)">
                {{ 'FOOTER.TERMS' | translate }}
            </span>
        </div>
        <div class="twc-col-md-3">
            <span class="twc-body link" (click)="templateService.showTemplate(templateTypes.PRIVACY)">
                {{ 'FOOTER.PRIVACY_STATEMENT' | translate }}
            </span>
        </div>
        <div class="twc-col-md-1"></div>
    </div>
</footer>